import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const MoodsWrapper = styled.div<{
  mobile: boolean
  isCampaign: boolean
}>`
  position: relative;
  padding: ${({ mobile }) => (mobile ? `0 24px 39px 0` : `40px 24px 0px 23px`)};
  ${({ isCampaign }) => (isCampaign ? 'padding: 0 0 39px 0;' : '')}
  ${({ mobile }) => (mobile ? `margin-bottom: 50px;` : ``)}
`

export const MoodsTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: ${colors.mainText};
  font-weight: 400;
  margin-bottom: 16px;
  @media (min-width: 576px) {
    margin-bottom: 16px;
  }
`

export const ChristmasTooltip = styled.div<{ mobile: boolean }>`
  position: absolute;
  top: ${({ mobile }) => (mobile ? -10 : -8)}px;
  left: ${({ mobile }) => (mobile ? 0 : 125)}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  width: 290px;
  background: #000;
  border-radius: 8px;
  z-index: 2;

  img {
    height: 16px;
    width: 13px;
  }
  span {
    font-size: 14px;
    color: #fff;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 16px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #000;
  }
`

export const MoodsCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  color: ${colors.mainText};
  line-height: 21px;
  font-size: 14px;
`

export const MoodsCheckboxLabel = styled.span`
  font-size: 14px;
  color: ${colors.mainText};
`
